<template>
  <b-col lg="12">
    <modal-adicionar-itens ref="adicionar-itens-pedido"/>
    <!-- Aviso ANTECIPADO de budget (doação WD): estouro por categoria ELT/GL -->
    <b-alert
      v-if="isPedidoDoacaoAtual && avisosBudgetCarrinho.length"
      show
      :variant="budgetCarrinhoBloqueia ? 'danger' : 'warning'"
      class="mb-1"
    >
      <div class="p-50">
        <feather-icon icon="AlertTriangleIcon" class="mr-50" />
        <strong>{{ budgetCarrinhoBloqueia ? 'Budget insuficiente' : 'Atenção ao budget' }}</strong>
        <div v-for="(msg, i) in avisosBudgetCarrinho" :key="`bw-${i}`" class="small mt-25">{{ msg }}</div>
        <div v-if="budgetMisto" class="small mt-25">
          O pedido tem itens ELT e GL — na finalização ele será dividido em dois pedidos (um por categoria), mediante sua confirmação.
        </div>
      </div>
    </b-alert>
    <b-col>
      <div class="demo-inline-spacing">
        <b-button
            class="mr-2 bg-secondary bg-darken-2 border-0"
            :to="{ name: 'pedidos-vendas' }"
        >
          <feather-icon icon="ArrowLeftCircleIcon" size="18"/>
          Voltar
        </b-button>
        <b-button
            class="mr-2 bg-success bg-darken-2 border-0"
        >
          <feather-icon icon="SaveIcon" size="18"/>
           Salvar
        </b-button>
      </div>
    </b-col>
    <b-col md="12" class="mt-2">
      <b-card no-body>
        <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
          <b-card-title>Pedido</b-card-title>
        </b-card-header>
        <b-tabs card pills nav-class="nav-pill-primary">
          <b-tab>
            <template #title>
              <feather-icon icon="PocketIcon"/>
              <span>Condições</span>
            </template>
            <b-row>
              <b-col class="mt-2 mb-2">
              <validation-observer
                  ref="accountRules"
                  tag="form"
              >
                <b-row cols="12">
                  <b-col
                      cols="12"
                      class="mb-2"
                  >
                    <h5 class="mb-0">
                      NR Pré-Pedido
                    </h5>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="Representante"
                        label-for="Representante"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Representante"
                          rules="required"
                      >
                        <b-input-group>
                          <b-form-input
                              id="Representante"
                              v-model="formInfoPedido.dataCapaPedido.representanteid"
                              :state="errors.length > 0 ? false:null"
                              placeholder="Representante"
                              @blur="onChageCodigoRepresentante"
                              @keyup.enter="onChageCodigoRepresentante"
                          />
                          <b-input-group-append>
                            <b-button variant="outline-primary"  v-b-modal.modal-buscar-representante
                                      @click="loadingRepresentantes"
                            >
                              <b-spinner small v-if="getIsLoadingCapaPedido"/>
                              <feather-icon v-else icon="SearchIcon"/>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="Nome Representante"
                        label-for="nome Representante"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="nome_representante"
                          vid="nome_representante"
                          rules="required"
                      >
                        <b-form-input
                            id="nome_representante"
                            v-model="formInfoPedido.dataCapaPedido.representantenome"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Nome Representante"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="Cod. Estabelecimento"
                        label-for="cod_estabelecimento"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Cod. Estabelecimento"
                          vid="cod_estabelecimento"
                          rules="required"
                      >
                        <b-form-input
                            id="cod_estabelecimento"
                            v-model="formInfoPedido.dataCapaPedido.estabelecimentoid"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Cod. Estabelecimento"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                        label="Razão Social"
                        label-for="razao_social"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Razão Social"
                          vid="razao_social"
                          rules="required"
                      >
                        <b-form-input
                            id="razao_social"
                            v-model="formInfoPedido.dataCapaPedido.estabelecimentorazaosocial"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Razão Social"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="Cliente"
                        label-for="Cliente"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Cliente"
                          rules="required"
                      >
                        <b-input-group>
                          <b-form-input
                              id="Cliente"
                              v-model="formInfoPedido.dataCapaPedido.clienteiderp"
                              :state="errors.length > 0 ? false:null"
                              placeholder="Cliente"
                              @blur="onChagenCliente"
                              @keyup.enter="onChagenCliente"
                              :disabled="!formInfoPedido.dataCapaPedido.representanteid"
                          />
                          <b-input-group-append>
                            <b-button variant="outline-primary"  v-b-modal.modal-buscar-cliente-info-pedido
                                      @click="loadingClientes">
                              <b-spinner small v-if="getIsLoadingCliente"/>
                              <feather-icon v-else icon="SearchIcon"/>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                        label="Nome Cliente"
                        label-for="nome_cliente"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nome Cliente"
                          vid="nome_cliente"
                          rules="required"
                      >
                        <b-form-input
                            id="nome_cliente"
                            v-model="formInfoPedido.dataCapaPedido.cliente_nome"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Nome Cliente"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        v-if="$store.getters['preferencias/condicaoPagamentoAtiva']"
                        label="Condição de Pagamento"
                        label-for="condicao_pagamento"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Condição de Pagamento"
                          rules="required"
                      >
                        <b-input-group>
                          <b-form-input
                              id="condicao_pagamento"
                              v-model="formInfoPedido.dataCapaPedido.condicaopagamentoid"
                              :state="errors.length > 0 ? false:null"
                              placeholder="Condição de Pagamento"
                              :disabled="!formInfoPedido.dataCapaPedido.clienteiderp"
                          />
                          <b-input-group-append>
                            <b-button variant="outline-primary" v-b-modal.modal-buscar-condpgto-info-pedido>
                              <feather-icon icon="SearchIcon" v-b-modal.modal-buscar-condpgto-info-pedido/>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                        v-if="$store.getters['preferencias/condicaoPagamentoAtiva']"
                        label="Descrição Condição de Pagamento"
                        label-for="descricao_condicao_pagamento"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Descrição Condição de Pagamento"
                          vid="descricao_condicao_pagamento"
                          rules="required"
                      >
                        <b-form-input
                            id="descricao_condicao_pagamento"
                            v-model="formInfoPedido.dataCapaPedido.condicaopagamentodescricao"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Descrição Condição de Pagamento"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="Tipo Pedido"
                        label-for="Tipo Pedido"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Tipo Pedido"
                          vid="nr_oc"
                          rules="required"
                      >
                        <b-form-input
                            id="tipopedidoid"
                            v-model="formInfoPedido.dataCapaPedido.tipopedidoid"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Tipo Pedido"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Tipo Endereco" label-for="tipoendereco">
                      <b-form-input
                          id="tipoendereco"
                          v-model="formInfoPedido.enderecoEntrega.tipoenderecoid"
                          disabled
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="Nr. OC"
                        label-for="nr_oc"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nr. OC"
                          vid="nr_oc"
                          rules="required"
                      >
                        <b-form-input
                            id="nr_oc"
                            v-model="formInfoPedido.dataCapaPedido.nr_oc"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Nr. OC"
                            maxlength="12"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                        label="Pedido número representante"
                        label-for="pedidonumerorepresentante"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="pedidonumerorepresentante"
                          vid="pedidonumerorepresentante"
                          rules="required"
                      >
                        <b-form-input
                            id="naturezaoperacaodescricao"
                            v-model="formInfoPedido.dataCapaPedido.pedidonumerorepresentante"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Pedido número representante"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row cols="12">
                  <b-col md="12">
                    <b-form-group
                        label="Local de Entrega"
                        label-for="Local de Entrega"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Local de Entrega"
                          vid="Local de Entrega"
                          rules="required"
                      >
                        <b-form-input
                            id="nr_oc"
                            v-model="formInfoPedido.enderecoEntrega.clienteendereco"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Local de Entrega"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <!-- Endereço de entrega alternativo (mesma UF; busca por CEP) -->
                    <escolher-endereco-entrega
                      v-model="enderecoAlternativo"
                      :clienteid="formInfoPedido.enderecoEntrega && formInfoPedido.enderecoEntrega.clienteid"
                      :uf-atual="String((formInfoPedido.enderecoEntrega && formInfoPedido.enderecoEntrega.ufid) || '').trim()"
                      class="mb-1"
                    />
                  </b-col>
                </b-row>
                <b-row cols="12">
                  <b-col md="2">
                    <b-form-group
                        label="Natureza Operação"
                        label-for="Natureza Operação"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Natureza Operação"
                          rules="required"
                      >
                        <b-input-group>
                          <b-form-input
                              id="Natureza Operação"
                              v-model="formInfoPedido.dataCapaPedido.naturezaoperacaoid"
                              :state="errors.length > 0 ? false:null"
                              placeholder="Codigo Natureza Operacao"
                              disabled
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="Nome Natureza Operação"
                        label-for="nome Natureza Operação"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="naturezaoperacaodescricao"
                          vid="naturezaoperacaodescricao"
                          rules="required"
                      >
                        <b-form-input
                            id="naturezaoperacaodescricao"
                            v-model="formInfoPedido.dataCapaPedido.naturezaoperacaodescricao"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Nome Natureza Operação"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="Canal Venda"
                        label-for="Canal Venda"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Canal Venda"
                          rules="required"
                      >
                        <b-input-group>
                          <b-form-input
                              id="Canal Venda"
                              v-model="formInfoPedido.dataCapaPedido.canal_venda_id"
                              :state="errors.length > 0 ? false:null"
                              placeholder="Codigo Canal Venda"
                              disabled
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="Nome Canal Venda"
                        label-for="nome Canal Venda"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="canalvendadescricao"
                          vid="canalvendadescricao"
                          rules="required"
                      >
                        <b-form-input
                            id="canalvendadescricao"
                            v-model="formInfoPedido.dataCapaPedido.canal_venda_descricao"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Nome Canal Venda"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row cols="12">
                  <b-col md="3" v-if="$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false">
                    <b-form-group
                        label="Data Entrega"
                        label-for="Data Entrega"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="pedidodataentrega"
                          vid="pedidodataentrega"
                          rules="required"
                      >
                        <b-form-input
                            id="pedidodataentrega"
                            v-model="formInfoPedido.enderecoEntrega.dataPrevistaEntrega"
                            type="date"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Data Entrega"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="3" v-if="$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false">
                    <b-form-group
                        label="Data Entrega Original"
                        label-for="pedidodataentregaprevista"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="pedidodataentregaprevista"
                          vid="pedidodataentregaprevista"
                          rules="required"
                      >
                        <b-form-input
                            id="pedidodataentregaprevista"
                            v-model="formInfoPedido.enderecoEntrega.dataPrevistaEntrega"
                            type="date"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Data Entrega Original"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row cols="12">
                  <b-col md="12">
                    <b-form-group
                        label="Observações"
                        label-for="textarea-rows"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Observações"
                          vid="observacoes"
                          rules="required|observacoes"
                      >
                        <b-form-textarea
                            id="textarea-rows"
                            v-model="formInfoPedido.dataCapaPedido.observacoes"
                            placeholder=""
                            rows="8"
                        />
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row cols="12">
                  <b-col md="2">
                   <b-form-group
                      label="Tipo Frete"
                      label-for="tipofrete"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Tipo Frete"
                        rules="required"
                    >
                      <b-input-group>
                        <b-form-select
                            id="Tipo Frete"
                            v-model="formInfoPedido.dataCapaPedido.tipofrete"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Tipo Frete"
                        >
                          <option value="CIF" @click="preencherTransportadora('CIF')">CIF</option>
                          <option value="FOB" @click="preencherTransportadora('FOB')">FOB</option>
                        </b-form-select>
                      </b-input-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group
                        label="Transportadora"
                        label-for="Transportadora"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Transportadora"
                          rules="required"
                      >
                        <b-input-group>
                          <b-form-input
                              id="Transportadora"
                              v-model="formInfoPedido.dataCapaPedido.transportadoraid"
                              :state="errors.length > 0 ? false:null"
                              placeholder="Transportadora"
                              disabled
                          />
                          <b-input-group-append>
                            <b-button variant="outline-primary"
                                      v-b-modal.modal-buscar-transportadora
                                      disabled
                            >
                              <b-spinner small v-if="getIsLoadingCapaPedido"/>
                              <feather-icon v-else icon="SearchIcon"/>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="Nome Transportadora"
                        label-for="nome Transportadora"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="nome_transportadora"
                          vid="nome_transportadora"
                          rules="required"
                      >
                        <b-form-input
                            id="nome_representante"
                            v-model="formInfoPedido.dataCapaPedido.transportadoranome"
                            type="text"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Nome Transportadora"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

              </validation-observer>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="ListIcon"/>
              <span>Itens</span>
            </template>
            <b-col>
              <div class="demo-inline-spacing">
                <b-button
                    variant="success"
                    @click="openModal"
                >
                  <feather-icon icon="PlusIcon" size="18"/>
                  Novo
                </b-button>
              </div>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
            <b-table
                :items="getListTabelaItens"
                :fields="fieldsVisuais"
                striped
                responsive
                :striped="true"
                :bordered="true"
                :hover="true"

            >
              <template #cell(valorUnitario)="row">
                {{ dinheiroVisual(precoUnitarioVisual(row.item)) }}
              </template>
              <template #cell(valorTotal)="row">
                {{ dinheiroVisual(subtotalVisual(row.item)) }}
              </template>

              <template #cell(acoes)="data">
                <b-button
                    size="sm"
                    class="mr-2 bg-primary bg-darken-2 border-0"
                >
                  <feather-icon icon="SearchIcon" class="rotate-icon"/>
                </b-button>

                <b-button
                    size="sm"
                    class="mr-2 bg-danger bg-darken-5 border-0"
                    @click="removeItem(data)"
                >
                  <feather-icon icon="TrashIcon"/>
                </b-button>
              </template>
            </b-table>
            <b-row class="mt-3">
              <b-col md="6">
                <b-form-group label="Quantidade Total de Itens">
                  <b-form-input type="text" v-model="formInfoPedido.quantidadeTotalItens" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Valor Total do Pedido">
                  <b-form-input type="text" :value="dinheiroVisual(somaVisual(getListTabelaItens))" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-col>
</template>

<script>
import precoVisualizacaoMixin from '../pedidosVendas/modal/precoVisualizacao.mixin';
import {
  BTabs,
  BTab,
  BCardText,
  BCard,
  BCol,
  BCardHeader,
  BFormSelect,
  BFormInput,
  BRow,
  BFormGroup, BButton, BTable, BFormCheckbox, BCardFooter, BAlert,
} from 'bootstrap-vue';
import { required } from '@core/utils/validations/validations';
import { mapActions, mapGetters } from 'vuex';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ModalAdicionarItens from '@/views/app/operacoes/pedidosVendasPadrao/modal/modalAdicionarItens.vue';
import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import SLSEsPrioriService from '@/services/SistemaDKP/SLSEsPriori.service';
import Swal from 'sweetalert2';
import { avisarSeClienteSemEndereco } from '@/utils/impostoSimulador';
import { isPedidoDoacao } from '@/libs/perfilCliente';
import BudgetClient from '@/api/Budget/budget.client';
import { itensBudgetOperacao } from '@/utils/budgetCarrinhoItens';
import EscolherEnderecoEntrega from '@/components/pedidos/EscolherEnderecoEntrega.vue';

const budgetClient = new BudgetClient();

const slsRepresentanteService = new SLSRepresentanteService();
const slsClienteService = new SLSClienteService();
// const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const slsEsPrioriService = new SLSEsPrioriService();
export default {
  mixins: [precoVisualizacaoMixin],
  components: {
    ModalAdicionarItens,
    BCardFooter,
    BButton,
    BFormGroup,
    BRow,
    BFormInput,
    BFormSelect,
    BCardHeader,
    BCol,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BTable,
    BFormCheckbox,
    BAlert,
    AppCollapse,
    AppCollapseItem,
    EscolherEnderecoEntrega,
  },
  data: () => ({
    collapseType: 'border',
    selected: null,
    required,
    // Pré-checagem de budget (doação WD) por categoria ELT/GL.
    budgetCarrinho: null,
    budgetCheckTimer: null,
    budgetCheckSeq: 0,
    // Endereço de entrega alternativo escolhido no fechamento (null = padrão).
    enderecoAlternativo: null,
    fields: [
      { key: 'item_id', label: 'Código', sortable: true },
      { key: 'item_descricao', label: 'Descrição', sortable: true },
      { key: 'quantidade', label: 'Quantidade', sortable: true },
      { key: 'valorUnitario', label: 'Valor Unitario', sortable: true },
      { key: 'valorTotal', label: 'Valor Total', sortable: true },
      { key: 'acoes', label: 'Ações', sortable: true },
    ],
  }),
  watch: {
    'formInfoPedido.dataCapaPedido.tipofrete': function (newValue, oldValue) {
      if (newValue === 'CIF') {
        this.formInfoPedido.dataCapaPedido.transportadoraid = this.formInfoPedido.transportadoraCif[0].transportadoraid;
        this.formInfoPedido.dataCapaPedido.transportadoranome = this.formInfoPedido.transportadoraCif[0].transportadoranome;
      } else if (newValue === 'FOB') {
        this.formInfoPedido.dataCapaPedido.transportadoraid = this.formInfoPedido.transportadoraFob[0].transportadoraid;
        this.formInfoPedido.dataCapaPedido.transportadoranome = this.formInfoPedido.transportadoraFob[0].transportadoranome;
      } else {
        // Limpe o valor se não for CIF nem FOB
        this.formInfoPedido.dataCapaPedido.transportadoraid = '';
      }
    },
    // Reavalia o budget conforme itens/tipo mudam (aviso antecipado de estouro).
    getListTabelaItens: {
      deep: true,
      handler() { this.agendarChecagemBudget(); },
    },
    isPedidoDoacaoAtual() { this.agendarChecagemBudget(); },
    'getFormData.dataCapaPedido.representanteid'() { this.agendarChecagemBudget(); },
  },

  methods: {
    ...mapActions('intensPedido', [
      'removeItemListTabelaItens',
      'clearCreatePedido',
    ]),
    async removeItem(item) {
      await this.removeItemListTabelaItens(item.index);
    },
    async preencherTransportadora(tipo) {
      if (tipo === 'CIF') {
        console.log('CIF', this.transportadoraCif[0].transportadoraid);
        this.formInfoPedido.dataCapaPedido.transportadoraid = this.transportadoraCif[0].transportadoraid;
      } else {
        this.formInfoPedido.dataCapaPedido.fretecif = 0;
      }
    },
    async openModal() {
      this.$refs['adicionar-itens-pedido'].show();
    },
    async loadingRepresentantes() {
      await slsRepresentanteService.listarRepresentanteInfoPedido();
    },
    async onChageCodigoRepresentante() {
      this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', true);

      if (!this.formInfoPedido.dataCapaPedido.representanteid) {
        await this.$store.dispatch('intensPedido/resetDataCapaPedido');
        return;
      }

      const representante = await slsRepresentanteService.show(this.formInfoPedido.dataCapaPedido.representanteid);
      if (!representante) {
        await this.$store.dispatch('intensPedido/resetDataCapaPedido');
        await Swal.fire({
          title: 'Representante não encontrado',
          text: 'O representante informado não foi encontrado, por favor, verifique o código informado!',
          icon: 'error',
          confirmButtonText: 'OK',
        })
          .finally(() => {
            this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
          });
        return;
      }
      this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
        representanteid: representante.representanteid,
        representantenome: representante.representantenome,
      });
      this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
    },
    async loadingClientes() {
      await slsClienteService.listarClienteInfoPedido();
    },
    async onChagenCliente() {
      this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', true);
      this.$store.commit('intensPedido/SET_IS_LOADING', true);

      await slsClienteService.getInfoPedidoNovo(this.formInfoPedido.dataCapaPedido.clienteiderp)
        .then(async (data) => {
          console.log('DATA', data);

          // Sem endereço com UF + cidade a TOTVS devolve imposto zerado sem
          // nenhum erro — avisa e LIMPA cliente/tabela/condição para impedir a compra.
          if (!avisarSeClienteSemEndereco(data)) {
            await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
            this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
              ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
              clienteiderp: '',
              cliente_nome: '',
              tabelaprecoid: '',
              tabelapreco_descricao: '',
              condicaopagamentoid: '',
              condicaopagamentodescricao: '',
            });
            this.formInfoPedido.dataCapaPedido.clienteiderp = '';
            return;
          }

          this.$store.commit('intensPedido/SET_IFO_CLIENTE', data);
          this.$store.commit('SLSCondicaoPagamento/SET_COND_PAGTOS', data.optionsCondPagtoCliente);

          // await slsTabelapreco.getTabelaPrecoByClienteIdERP(data.cliente.clienteiderp)
          // this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
          //   representante: this.formInfoPedido.representante,
          //   ...data,
          // })
        })
        .catch((error) => {
          this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
          Swal.fire({
            title: error.response.data.title,
            text: error.response.data.message,
            icon: 'error',
            confirmButtonText: 'OK',
          });
          this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
          this.$store.commit('intensPedido/SET_IS_LOADING', false);
        })
        .finally(() => {
          this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
          this.$store.commit('intensPedido/SET_IS_LOADING', false);
        });
    },
    // ── Pré-checagem de budget (doação WD) por categoria ELT/GL ──
    agendarChecagemBudget() {
      this.budgetCheckSeq += 1;
      this.budgetCarrinho = null;
      if (this.budgetCheckTimer) clearTimeout(this.budgetCheckTimer);
      this.budgetCheckTimer = null;
      if (!this.isPedidoDoacaoAtual || !this.getFormData?.dataCapaPedido?.representanteid
        || !itensBudgetOperacao(this.getListTabelaItens).length) return;
      this.budgetCheckTimer = setTimeout(() => this.verificarBudgetCarrinho(), 600);
    },
    async verificarBudgetCarrinho() {
      this.budgetCheckTimer = null;
      const seq = ++this.budgetCheckSeq;
      this.budgetCarrinho = null;
      if (!this.isPedidoDoacaoAtual) return;
      const representanteid = this.getFormData?.dataCapaPedido?.representanteid;
      const itens = itensBudgetOperacao(this.getListTabelaItens);
      if (!representanteid || !itens.length) return;
      try {
        const { data: res } = await budgetClient.validarCarrinho({ representanteid, itens });
        if (seq !== this.budgetCheckSeq) return; // resposta antiga: descarta
        this.budgetCarrinho = res && res.data;
      } catch (e) {
        if (seq === this.budgetCheckSeq) this.budgetCarrinho = null; // best-effort
      }
    },
    async onSubmit() {
      // Este fluxo é de Venda Padrão: ID Nexus pertence somente a doação (WD).
      const idNexus = '';
      const payload = {
        idnexus: idNexus,
        clienteid: this.getFormData.enderecoEntrega.clienteid,
        tipopedidoid: this.getFormData.dataCapaPedido.tipopedidoid,
        condicaopagamentoid: this.getFormData.dataCapaPedido.condicaopagamentoid,
        tabelaprecoid: this.getFormData.dataCapaPedido.tabelaprecoid,
        pedidoobservacoes: this.getFormData.dataCapaPedido.observacoes,
        pedidourgente: false,
        pedidodataentrega: this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidodataentregaprevista: this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidovalortotal: this.getTotalPedido,
        tipoenderecoid: this.getFormData.enderecoEntrega.tipoenderecoid,
        pedidooccliente: this.getFormData.dataCapaPedido.nr_oc,
        pedidoconsumidorfinal: true,
        pedidoprioridade: this.getFormData.dataCapaPedido.prioridade_pedido,
        canalvendaid: this.getFormData.dataCapaPedido.canalvendaid,
        cod_priori: this.getFormData.dataCapaPedido.prioridade_pedido,
        representanteid: this.getFormData.dataCapaPedido.representanteid,
        estabelecimentoid: this.getFormData.dataCapaPedido.estabelecimentoid,
        itemsPedido: this.getListTabelaItens,
        ...(this.enderecoAlternativo ? {
          pedidoentregaendereco: this.enderecoAlternativo.endereco,
          pedidoentreganumero: this.enderecoAlternativo.numero,
          pedidoentregacomplemento: this.enderecoAlternativo.complemento,
          pedidoentregabairro: this.enderecoAlternativo.bairro,
          pedidoentregacidade: this.enderecoAlternativo.cidade,
          pedidoentregauf: this.enderecoAlternativo.uf,
          pedidoentregacep: this.enderecoAlternativo.cep,
        } : {}),
      };
      try {
        let response = await slsPedidosService.finalizarPedidoOperacao(payload);

        // Doação com itens ELT e GL: backend pede confirmação para dividir
        // em dois pedidos (um por categoria) antes de criar qualquer coisa.
        const divisao = response?.data?.precisaDividirCategorias ? response.data : null;
        if (divisao) {
          const fmt = v => (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
          const conf = await Swal.fire({
            title: 'Dividir pedido por categoria?',
            html: 'O pedido tem itens das duas categorias de budget e será dividido em <strong>dois pedidos</strong>:<br/><br/>'
              + `<strong>ELT</strong>: ${divisao.categorias.ELT.totalItens} item(ns) — ${fmt(divisao.categorias.ELT.valor)}<br/>`
              + `<strong>GL</strong>: ${divisao.categorias.GL.totalItens} item(ns) — ${fmt(divisao.categorias.GL.valor)}`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, dividir e finalizar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            reverseButtons: true,
          });
          if (!conf.isConfirmed) return;
          response = await slsPedidosService.finalizarPedidoOperacao({ ...payload, confirmarDivisaoCategorias: true });
        }

        const dividido = response?.data?.dividido && Array.isArray(response.data.pedidos);
        const htmlSucesso = dividido
          ? `Seu pedido foi dividido por categoria de budget:<br/>${response.data.pedidos
            .map(p => `<strong>${p.categoria}</strong>: Pedido <strong>#${p.pedidoid}</strong>`)
            .join('<br/>')}`
          : `Seu pedido foi finalizado com sucesso! Número do Pedido: <strong>#${response.data.data.pedidoid}</strong>`;

        await Swal.fire({
          title: 'Pedido salvo com sucesso!',
          html: htmlSucesso,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.clearCreatePedido();
          this.$router.push({ name: 'pedidos-vendas' });
        });
      } catch (error) {
        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message || 'Ocorreu um erro ao salvar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    async voltar() {
      this.clearCreatePedido();
      this.$router.push({ name: 'pedidos-vendas-padrao' });
    },
  },
  computed: {
    fieldsVisuais() {
      return this.fields.map(field => field.key === 'valorUnitario'
        ? { ...field, label: this.rotuloUnitarioVisual(field.label) } : field);
    },
    ...mapGetters('SLSRepresentante', {
      representante: 'selectedRepresentante',
    }),
    ...mapGetters('InfoPedido', {
      getFormInfoPedido: ' GET_FORM_INFO_PEDIDO',
      getLoadingRepresentante: 'GET_LOADING_REPRESENTANTE',
    }),
    ...mapGetters('intensPedido', {
      getFormData: 'getFormData',
      getIsLoadingCapaPedido: 'getIsLoadingCapaPedido',
      getIsLoadingCliente: 'getIsLoadingCliente',
      getListTabelaItens: 'getlistarTabelaItens',
      getTotalPedido: 'getTotalPedido',
      getItemsPedidosArray: 'getItemsPedidosArray',
    }),
    formInfoPedido: {
      get() {
        return this.getFormData;
      },
      set(value) {
        this.$store.commit('intensPedido/SET_CAPA_PEDIDO', value);
      },
    },
    isPedidoDoacaoAtual() {
      return isPedidoDoacao(this.getFormData?.dataCapaPedido?.tipopedidoid);
    },
    avisosBudgetCarrinho() {
      const cats = (this.budgetCarrinho && this.budgetCarrinho.categorias) || {};
      return Object.values(cats).map(c => c && c.mensagem).filter(Boolean);
    },
    budgetCarrinhoBloqueia() {
      const cats = (this.budgetCarrinho && this.budgetCarrinho.categorias) || {};
      return Object.values(cats).some(c => c && c.bloqueia);
    },
    budgetMisto() {
      return !!(this.budgetCarrinho && this.budgetCarrinho.misto);
    },
  },
  async mounted() {
    await slsEsPrioriService.selectPrioridadePedido();
  },
  beforeDestroy() {
    this.budgetCheckSeq += 1;
    if (this.budgetCheckTimer) clearTimeout(this.budgetCheckTimer);
  },
};
</script>
